import { ICommand } from "../../modules/records/commands/i-command";
import { RecordsManager } from "../../modules/records/records-manager";
import { IExcelDownloadTime } from "../../modules/pages/fieldwork-report/models/excel-download-time";

export class DisplayDownloadExcelTimeCommand<T extends object> implements ICommand<T> {
  layout: "flat" | "raised" | "normal" = "normal";
  icon = "schedule";
  isLoading = false;

  private receiver!: RecordsManager<T>;

  constructor(private excelDownloadTimes: IExcelDownloadTime[]) { }

  get label(): string {
    const rowCount = this.receiver?.paginator?.length ?? 0;
    if (!rowCount || !this.excelDownloadTimes.length) return "";
    const nearest = this.excelDownloadTimes.reduce((prev, curr) =>
      Math.abs(curr.quantity - rowCount) < Math.abs(prev.quantity - rowCount) ? curr : prev
    );
    let mmSS = "1h +";
    if (nearest.minutes < 60) mmSS = this.convertMinutesToMMSS(nearest.minutes);
    return `~ ${mmSS}`;
  }


  convertMinutesToMMSS(minutes: number): string {
    const totalSeconds = Math.round(minutes * 60);
    const mm = Math.floor(totalSeconds / 60);
    const ss = totalSeconds % 60;
    if (mm <= 0)
      return `${ss.toString().padStart(2, '0')}s`;
    else
      return `${mm.toString().padStart(2, '0')}m ${ss.toString().padStart(2, '0')}s`;
  }
  execute(): void { }

  setReceiver(receiver: RecordsManager<T>): void {
    this.receiver = receiver;
  }

  isDisabled(): boolean {
    return false;
  }
}
